import * as types from './mutation-types'

export default {
  [types.SCHEDULES_INIT] (state, result) {
    state.schedules = result
  },

  [types.SELECT_SCHEDULE] (state, result) {
    Object.assign(state, result)
  },

  [types.CHANGE_DATE_END] (state, result) {
    state.end = result
  }
}



// WEBPACK FOOTER //
// ./src/store/schedules/mutations.js